<template>
  <div>
    <div>
      <div
        class="bg-white list-card p-2"
        :class="hasStepGuide ? 'border-content' : ''"
        data-testid="usdt-follow-instruction-section"
      >
        <div>
          <div class="d-md-flex justify-content-between align-items-center">
            <h4
              class="mb-0"
              data-testid="usdt-follow-instruction-title"
            >
              {{ $t('payment.wiseTransfer.titleFollowInstruction') }}
            </h4>
            <div
              v-if="false"
              class="d-flex align-items-center mt-2 mt-md-0"
            >
              <p class="mb-0 font-20 mr-1">
                Time remaining:
              </p>
              <div
                class="rounded-lg d-flex justify-content-center"
                style="background: #2667ff4d; padding: 12px 0; margin-right: 8px; min-width: 48px"
              >
                <p class="font-24 mb-0 font-weight-bold">
                  {{ formatTime(expiresIn).minutes }}
                </p>
              </div>
              <p class="font-20 mb-0 font-weight-600">
                :
              </p>
              <div
                class="rounded-lg d-flex justify-content-center"
                style="background: #2667ff4d; padding: 12px 0; margin-left: 8px; min-width: 48px"
              >
                <p class="font-24 mb-0 font-weight-bold">
                  {{ formatTime(expiresIn).seconds }}
                </p>
              </div>
            </div>
          </div>

          <div class="mt-1 d-flex">
            <div class="step-number">
              1
            </div>
            <p
              data-testid="content-instruction-1-usdt"
              class="font-14 font-weight-600 mb-0"
            >
              {{ $t('payment.USDT.firstFollowInstruction') }}
            </p>
          </div>

          <div
            data-testid="content-wallet-usdt"
            class="wallet-content"
          >
            <wallet-input :transfer="transfer" />
            <hr class="horizontal-divide">
            <!-- transfer network -->
            <b-row>
              <b-col md="4">
                <label
                  data-testid="label-usdt-wallet-address"
                  class="font-14"
                >
                  {{ $t('payment.USDT.labelTransferNetwork') }}
                </label>
              </b-col>
              <b-col
                data-testid="transfer-network-wallet-usdt"
                md="8"
              >
                <strong
                  data-testid="transfer-value-wallet-usdt"
                  class="mr-1"
                >
                  {{ transfer.value }}
                </strong>
                <span data-testid="transfer-name-wallet-usdt">
                  {{ transfer.name }}
                </span>
              </b-col>
            </b-row>
            <!-- total amount -->
            <b-row class="mt-1 align-items-center">
              <b-col md="4">
                <label
                  data-testid="label-total-amount-wallet-usdt"
                  class="font-20"
                >
                  {{ $t('addFundPage.creditCardPayment.textTotalAmount') }}
                </label>
              </b-col>
              <b-col
                data-testid="total-amount-wallet-usdt"
                md="8"
                class="d-flex align-items-center"
              >
                <strong
                  data-testid="amount-wallet-usdt"
                  class="mr-1 total-amount"
                >
                  {{ verification.bankTransferAmount }}
                </strong>
                <strong
                  data-testid="currency-usdt"
                  class="currency-usdt"
                >
                  {{ paymentMethod.value }}
                </strong>
                <btn-loading
                  class="btn-height btn-text-color ml-2"
                  variant-convert="btn-submit"
                  style="border-radius: 12px !important;"
                  @click="handleCopyAmount(verification.bankTransferAmount)"
                >

                  <div class="d-flex flex-nowrap align-items-center">
                    <feather-icon
                      icon="CopyIcon"
                      size="18"
                      class="d-none d-lg-block"
                      style="margin-right: 6px"
                    />
                    <p
                      class="mb-0 width-max d-none d-lg-block"
                      style="font-size: 16px"
                    >
                      {{ $t('payment.USDT.copyAmount') }}
                    </p>
                    <p
                      class="mb-0 width-max d-lg-none d-block"
                      style="font-size: 16px"
                    >
                      {{ $t('payment.USDT.copy') }}
                    </p>
                  </div>
                </btn-loading>
              </b-col>
              <div class="warning-message mx-1 mt-2 d-flex align-items-center w-100">
                <img
                  style="margin-right: 8px"
                  alt="alert"
                  :src="require('@/assets/images/common/ic-warning-red.svg')"
                >
                <p
                  class="mb-0 font-weight-bold"
                  style="color: #e11c4e"
                >{{ $t('payment.USDT.notice1') }}
                  <span
                    class="font-weight-bold"
                    style="color: #27a27a; font-size: 22px"
                  >${{ verification.bankTransferAmount }}
                  </span>
                  {{ $t('payment.USDT.notice2') }}
                </p>
              </div>
            </b-row>
            <hr class="horizontal-divide">
            <div
              data-testid="content-note-info-wallet-usdt"
            >
              <p
                style="margin-bottom: 4px"
                data-testid="title-note-info-wallet-usdt"
              >
                {{ $t('payment.USDT.titleNoteInfoUSDT') }}:
              </p>
              <p
                data-testid="text-first-note-info-wallet-usdt"
                class="point"
              >
                {{ $t('payment.USDT.firstNoteInfoUSDT', {payment: paymentMethod.value}) }}
              </p>
              <div
                data-testid="text-second-note-info-wallet-usdt"
                class="point"
              >
                <span>🔥 {{ $t('payment.USDT.secondNoteInfoUSDT') }} </span>
                <span
                  v-if="!transfer.name"
                  data-testid="transfer-value-note-info-wallet-usdt"
                  class="font-weight-600"
                >
                  {{ transfer.value }}
                </span>
                <span
                  v-else
                  data-testid="transfer-name-note-info-wallet-usdt"
                  class="font-weight-600"
                >
                  {{ transfer.name }}
                </span>
              </div>
            </div>
          </div>

          <div class="mt-2 d-flex">
            <div class="step-number">
              2
            </div>
            <p
              data-testid="content-instruction-2-usdt"
              class="font-14 font-weight-600"
            >
              {{ $t('payment.USDT.secondFollowInstruction') }}
            </p>
          </div>
          <div :class="hasStepGuide ? 'top-up-on-step' : 'top-up-form-container'">
            <div
              class="add-fund-form"
            >
              <validation-observer ref="formValidation">
                <b-form
                  data-testid="transactions-form-usdt"
                  class="transactions-form"
                >
                  <b-form-group
                    :label="$t('payment.USDT.labelIDTransactions')"
                    data-testid="label-id-transactions-usdt"
                    class="position-relative form-label"
                  >
                    <validation-provider
                      #default="{ errors }"
                      id="transactions-usdt"
                      :name="$t('payment.USDT.labelIDTransactions')"
                      rules="required"
                    >
                      <b-input-group
                        class="input-group-merge width-custom w-100"
                        :class="errors.length > 0 ? 'is-invalid' : null"
                      >
                        <b-form-input
                          v-model="transactionId"
                          class="input-height"
                          data-testid="usdt-transaction-id-input"
                          placeholder="EX: 123456789"
                          :state="errors.length > 0 ? false : null"
                        />
                      </b-input-group>
                      <small
                        v-if="errors[0]"
                        class="text-danger"
                        data-testid="usdt-transaction-id-error"
                      >
                        {{ errors[0] }}
                      </small>
                    </validation-provider>

                    <div class="mt-2">
                      <p
                        class="d-flex align-items-center upload"
                        data-testid="usdt-upload-attachment-btn"
                        @click="$refs.refImage.$el.click()"
                      >
                        <b-img
                          fluid
                          alt="img"
                          :src="
                            require('@/assets/images/pages/payment/ic-attachment-white.svg')
                          "
                        />
                        <span data-testid="placeholder-upload-img-usdt">
                          {{ $t('payment.wiseTransfer.placeHolderUploadImg') }}
                          <span
                            data-testid="type-upload-img-usdt"
                            class="font-14"
                          >(PDF, JPG, PNG)
                          </span>
                        </span>
                      </p>
                      <b-form-file
                        v-model="imageFile"
                        ref="refImage"
                        plain
                        accept=".jpg, .png, .pdf"
                        :hidden="true"
                        @input="inputImageRenderer"
                      />

                      <div
                        v-if="imageTransaction && imageFile && imageFile.name"
                        data-testid="text-valid-image-file"
                        class="form-label font-small-2"
                        style="margin-top: 5px"
                      >
                        <span
                          v-if="isPdfFile(imageFile)"
                          class="text-success"
                        >
                          {{ $t('payment.wiseTransfer.textUploaded') }}
                          <a
                            :href="imageTransaction"
                            target="_blank"
                            class="text-success cursor-pointer underline"
                          >{{ imageFile.name || imageTransaction.name }}</a>
                          {{ $t('payment.wiseTransfer.textSuccess') }}
                        </span>
                        <div
                          v-else
                          class="position-relative width-max image-transaction"
                        >
                          <b-img
                            :src="imageTransaction"
                            alt="img uploaded"
                          />
                          <div class="gallery-item-info">
                            <div
                              class="gallery-item-preview"
                              @click="previewImageTransaction"
                            >
                              <feather-icon
                                size="21"
                                icon="EyeIcon"
                              />
                            </div>
                            <feather-icon
                              size="21"
                              icon="Trash2Icon"
                              class="delete-screenshot cursor-pointer"
                              @click="deleteImageTransaction"
                            />
                          </div>
                        </div>
                      </div>

                      <small
                        v-if="imageError"
                        data-testid="text-error-image-file"
                        class="text-danger"
                      >
                        {{ $t('payment.wiseTransfer.errorRequiredAttachment') }}
                      </small>
                    </div>

                    <slide-step
                      class="mt-2"
                      :step="2"
                    />
                    <div
                      class="
                        d-flex
                        justify-content-between
                        font-14 font-medium
                        mb-2
                      "
                    >
                      <span data-testid="content-step2-usdt">
                        {{ $t('payment.wiseTransfer.placeHolderUploadImg') }}
                      </span>
                      <span>2/2</span>
                    </div>

                    <div
                      class="d-flex align-items-center justify-content-end mt-2"
                    >
                      <btn-loading
                        id="trigger-back-usdt"
                        class="mr-1 border-0"
                        variant-convert="btn-back"
                        pill
                        @click.prevent="handleClickPrev"
                      >
                        {{ $t('stepGuideControl.stepVerifyInfo.textBack') }}
                      </btn-loading>
                      <btn-loading
                        id="trigger-top-up-usdt"
                        span-id="trigger-top-up-usdt-child"
                        class="btn-height btn-text-color"
                        variant-convert="btn-submit"
                        pill
                        :loading="loading || paymentLoading"
                        @click.prevent="submit"
                      >
                        {{ $t('guidePopUp.guideTopUpWise.textDone') }}
                      </btn-loading>
                    </div>
                  </b-form-group>
                </b-form>
              </validation-observer>
            </div>

            <div class="line-center">
              <div class="horizontal-divide" />
            </div>

            <div
              data-testid="summary-step2-usdt-form"
              class="summary-form"
            >
              <summary-amount
                :verification="verification"
                :amount="amount"
                :payment-method="paymentMethod"
                :transfer="transfer"
                :amount-tip="amountTip || 0"
                :current-tip="currentTip || 0"
                :show-tips-input="showTipsInput"
                :transaction-type="transactionType"
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <show-screenshot-modal
      ref="open-screenshot-modal"
      :img="imageTransaction"
    />
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  VBTooltip,
  BFormInput,
  BInputGroup,
  BFormGroup,
  BForm,
  BImg,
  BFormFile,
} from 'bootstrap-vue'
import BtnLoading from '@/layouts/components/BtnLoading.vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'

import paymentMixin from '@/mixins/paymentMixin'
import gaTrackingMixin from '@/mixins/gaTrackingMixin'
import envMixin from '@/mixins/envMixin'
import generalConfigsMixin from '@/mixins/generalConfigsMixin'
import numberFormatMixin from '@/mixins/numberFormatMixin'
import stepGuideMixin from '@/mixins/stepGuideMixin'
import { toastification } from '@core/mixins/toast'
import { mapGetters, createNamespacedHelpers } from 'vuex'

import { ref } from '@vue/composition-api'
import { useInputImageRenderer } from '@core/comp-functions/forms/form-utils'
import { PAYMENT_METHOD, TICKET_TYPE, TRANSACTION_TYPE } from '@/constants'
import ShowScreenshotModal from '@/components/ShowScreenshotModal.vue'
import { deleteCookie } from '@/libs/common'
import SlideStep from '../SlideStep.vue'
import SummaryAmount from './Summary.vue'
import WalletInput from './WalletInput.vue'

const { mapActions } = createNamespacedHelpers('file')
const { mapActions: mapPaymentActions, mapGetters: mapPaymentGetters } = createNamespacedHelpers('payment')

export default {
  components: {
    ShowScreenshotModal,
    BRow,
    BCol,
    BtnLoading,
    BFormInput,
    BInputGroup,
    BFormGroup,
    BImg,
    BFormFile,
    BForm,
    ValidationProvider,
    ValidationObserver,
    SummaryAmount,
    WalletInput,
    // TopUpSuccess,
    SlideStep,
  },

  directives: {
    'b-tooltip': VBTooltip,
  },

  mixins: [
    paymentMixin,
    generalConfigsMixin,
    numberFormatMixin,
    toastification,
    stepGuideMixin,
    gaTrackingMixin,
    envMixin,
  ],

  props: {
    verification: {
      type: Object,
      required: false,
      default() {
        return {}
      },
    },

    paymentMethod: {
      type: Object,
      required: false,
      default() {
        return {}
      },
    },

    transfer: {
      type: Object,
      required: false,
      default() {
        return {}
      },
    },

    amount: {
      type: Number,
      required: true,
    },

    account: {
      type: Object,
      required: true,
    },

    // isToggle: {
    //   type: Boolean,
    //   required: true,
    // },

    transactionInfo: {
      type: String,
      required: true,
    },

    billing: {
      type: [Array, File],
      required: false,
      default() {
        return []
      },
    },

    amountTip: {
      type: Number || null,
      default: null,
    },

    currentTip: {
      type: Number || null,
      default: null,
    },

    showTipsInput: {
      type: Boolean,
      default: false,
    },

    transactionType: {
      type: String,
      default: '',
    },

    expiresIn: {
      type: Number || null,
      default: null,
    },
  },

  setup() {
    const refImage = ref(null)

    const { inputImageRenderer } = useInputImageRenderer(refImage, () => {})

    return {
      refImage,
      inputImageRenderer,
    }
  },

  data() {
    return {
      transactionId: this.transactionInfo || '',
      imageFile: this.billing,
      imageError: false,

      imageTransaction: '',
    }
  },

  computed: {
    ...mapGetters({
      user: 'auth/user',
      uploadStatus: 'file/status',
      fileUrl: 'file/fileUrl',
      loading: 'file/loading',
      uploadMessage: 'file/message',
      errorPayment: 'payment/errorPayment',
      paymentLoading: 'payment/loading',
    }),
    ...mapPaymentGetters(['message', 'status', 'loading', 'verificationUSDT', 'ticketAuto']),

    isPdfFile() {
      return imageFile => imageFile.type === 'application/pdf'
    },

    formatTime() {
      return time => {
        const mins = Math.floor(time / 60)
        const secs = time % 60
        return {
          minutes: mins < 10 ? `0${mins}` : mins,
          seconds: secs < 10 ? `0${secs}` : secs,
        }
      }
    },

    isBinanceID() {
      return this.transfer.value === this.$t('payment.USDT.labelBinanceUserID')
    },

    isInTrial() {
      return this.user?.isInTrial
    },

    amountValidate() {
      return !!(this.amount >= this.minAmount && this.amount <= this.maxAmount)
    },

    minAmount() {
      return 200
    },

    maxAmount() {
      return 100000
    },

    serviceCharge() {
      // return parseFloat(this.truncDigits(this.percentFee * this.amount)).toLocaleString('en-US')
      return this.amountFormat(this.percentFee * this.amount).toLocaleString(
        'en-US',
      )
    },

    percentFee() {
      return this.user?.data?.plans?.transferFee?.USDT || 0
    },

    percentFeeTxt() {
      return `${(this.percentFee * 100).toFixed(2)}%`
    },

    methodFee() {
      return this.generalConfigs?.paymentGateFee?.USDTGate || 0
    },

    methodFeeTxt() {
      return `${(this.methodFee * 100).toFixed(2)}%`
    },
  },

  watch: {
    imageFile(val) {
      if (val) {
        this.upload(val)
        this.imageError = false
      }
    },
  },

  methods: {
    ...mapActions(['uploadFile']),
    ...mapPaymentActions(['createRecharge', 'getListTicket', 'getHistoryLimit', 'requestAutoUSDT']),
    handleCopyAmount(amount) {
      window.navigator.clipboard.writeText(amount)
        .then(() => {
          this.toastSuccess(this.$t('payment.contentCopied', { name: 'Total amount' }))
        })
    },

    async upload(file) {
      if (file) {
        await this.uploadFile(file)
        if (this.uploadStatus) {
          this.toastSuccess(this.$t('payment.toastUploadSuccess'))
          this.imageTransaction = this.fileUrl
        } else {
          this.toastFailure(this.uploadMessage)
        }
      }
    },

    deleteImageTransaction() {
      this.imageTransaction = ''
      this.imageFile = null
    },

    previewImageTransaction() {
      this.$refs['open-screenshot-modal'].showModal()
    },

    handleClickPrev() {
      this.$emit('on-prev', {
        amount: this.amount,
        transactionId: this.transactionId,
        billing: this.imageFile,
        currentTip: this.currentTip,
        amountTip: this.amountTip,
        showTipsForAM: this.showTipsInput,
      })
    },

    async fetchListTicket() {
      const params = {
        types: [
          TICKET_TYPE.RECHARGE_USER_BALANCE,
          TICKET_TYPE.SETUP_COST,
        ],
        status: ['opening'],
      }
      await this.getListTicket({ params })
    },

    async fetchHistory() {
      const params = {
        page: 1,
        size: 5,
        types: [
          TRANSACTION_TYPE.RECHARGE_USER_BALANCE,
          TRANSACTION_TYPE.ADMIN_FIX_RECHARGE_MONEY,
          TRANSACTION_TYPE.SETUP_COST,
        ],
      }
      await this.getHistoryLimit(params)
    },

    submit() {
      if (!this.imageTransaction) {
        this.imageError = true
      }

      this.$refs.formValidation.validate().then(async success => {
        if (success && this.imageTransaction) {
          const params = {
            details: {
              note: this.transactionId,
              amount: this.amount,
              paymentMethod: 'USDT',
              coinType: this.paymentMethod.value,
              billingAttachment: this.imageTransaction,
              coinNetwork: this.transfer.value,
              tipAMAmount: this.amountTip,
            },
            // eslint-disable-next-line no-underscore-dangle
            verificationId: this.verification.id,
            verificationAmount: this.verification.bankTransferAmount,
          }

          await this.requestAutoUSDT(params)
          if (this.isOnlyEcomdyPlatform) {
            this.gaTrackingUserAddFund(params.details.amount, PAYMENT_METHOD.USDT) // GA Tracking
          }
          if (this.errorPayment.message) {
            this.toastFailure(this.errorPayment.message)
          } else {
            deleteCookie('add_fund_data')

            this.$emit('handleShowSuccess')
            // this.getUsdtAutoInfo(this.ticketAuto)

            if (this.isSetupCostModel && this.hasStepGuide) {
              this.fetchHistory()
            }
            this.$emit('handleShowSuccess')
          }
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables/_variables.scss';
  .step-number{
    min-width: 20px;
    height: 20px;
    background: $green;
    border-radius: 50px;
    line-height: 20px;
    color: white;
    font-size: 12px;
    text-align: center;
    margin: 2px 5px 0px 0px;
  }

  .point {
  margin-bottom: 4px;
  &::before {
    display: inline-block;
    content: "";
    width: 5px;
    height: 5px;
    border-radius: 50%;
    background-color: #000;
    margin-right: 5px;
    margin-bottom: 3px;
  }
  &.warning {
    color: #f22548;
  }
}

.upload {
  cursor: pointer;
  background: #f5f5f7;
  border: 1px dashed rgba(0, 0, 0, 0.1);
  border-radius: 14px;
  padding: 32px 0px;
  justify-content: center;

  img {
    max-width: 15px;
    margin-right: 5px;
  }
}

.text-back {
  color: #828287;
  margin-bottom: 24px;
}

.top-up-success {
  max-width: 410px;
  margin: 0 auto;
  margin-top: 42px;
}

.btn-back {
  color: rgb(22 33 62 / 76%) !important;
  background-color: rgba(0, 0, 0, 0.05) !important;
  padding: 11px 20px;
  font-size: 14px;
  font-weight: 600;
}

.wallet-content {
  margin: 32px 0px;
  border: 1px solid #eeeeee;
  background: #f5f5f7;
  border-radius: 16px;
  padding: 20px;
}

.horizontal-divide {
  margin: 20px 0px;
  border: 1px solid #e5e5e5;
}

.top-up-on-step {
  .line-center {
    display: none;
  }
}

.top-up-form-container {
  display: flex;

  .add-fund-form {
    width: 50%;
  }

  .line-center {
    margin: 0 1.5rem;
  }

  .summary-form {
    width: 50%;
  }

  @media (max-width: 1399px) {
    display: block;

    .add-fund-form {
      width: 100%;
    }

    .line-center {
      display: none;
    }

    .summary-form {
      width: 100%;
    }
  }
}
.total-amount{
  color: #27a27a;
  font-size: 30px;
  @media(max-width: 767px) {
    font-size: 24px;
  }
}

.currency-usdt {
  font-size: 20px;
  @media(max-width: 767px) {
    font-size: 18px;
  }
}

.border-content {
  border-radius: 0px 0px 24px 24px !important;
}

.warning-message {
  margin-top: 10px;
  background: rgba(225, 28, 78, 0.12);
  border-radius: 10px;
  padding: 10px 12px 10px 16px;
}

.image-transaction {
  max-width: 124px;
  height: 100px;
  margin-right: 3%;
  width: max-content;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #cccccc6e;
  border-radius: 8px;

  @media(max-width: 768px) {
    max-width: 47%;
  }

  img {
    max-width: 100%;
    max-height: 100%;
    width: auto;
  }

  &:last-child {
    margin: 0;
  }
}

.image-transaction {
  width: 200px;
  position: relative;
  flex: 1 0 22rem;
  color: #fff;

  &:hover .gallery-item-info,
  &:focus .gallery-item-info {
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.3);
  }

  .gallery-item-info {
    display: none;

    li {
      display: inline-block;
      font-size: 1.7rem;
      font-weight: 600;
    }

    .gallery-item-preview {
      cursor: pointer;
    }

    .gallery-item-delete {
      cursor: pointer;
    }

    .delete-screenshot {
      margin-left: 20px;
    }
  }
}
</style>
